export default {
    "lightMetricsVideo_error": "Error while getting video, please try again.",
    "lightMetricsVideo_liveNotAvailable": "A different livestream session is already active on the device, please try again later.",
    "lightMetricsVideo_liveNotAvailable_ignitionOff": "The vehicle is currently offline - unable to live stream",
    "lightMetricsVideo_joiningExistingSession": "Joining an already active live session",
}